import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from '../../environment/environment.service';
import { lastValueFrom } from 'rxjs';
import {
  CustomerDataChangeDTO,
  HTTPError,
  IPartnerDataChangeResponse,
  parsePartnerDataChangeItemDTO,
  PartnerDataChangeDTO,
  PartnerDataChangeStatusResponse,
} from '@mwe/models';

@Injectable({
  providedIn: 'root',
})
export class PartnerDataChangeService {
  private readonly http = inject(HttpClient);
  private readonly environmentService = inject(EnvironmentService);

  private resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/partner/';
  }

  async confirm(dataDTO: PartnerDataChangeDTO): Promise<IPartnerDataChangeResponse> {
    try {
      return await lastValueFrom(this.http.post<IPartnerDataChangeResponse>(this.getResourceUrl('change/confirm'), dataDTO));
    } catch (err) {
      throw new HTTPError(err.status, err.error);
    }
  }

  confirmStatus(submitId: number): Promise<IPartnerDataChangeResponse> {
    return lastValueFrom(this.http.get<IPartnerDataChangeResponse>(this.getResourceUrl('change/confirmStatus') + '?submitId=' + submitId));
  }

  getOrderStatusDetails(orderId: string): Promise<PartnerDataChangeDTO | CustomerDataChangeDTO> {
    return lastValueFrom(this.http.get<PartnerDataChangeStatusResponse>(this.resourceUrl + 'orderStatusDetails/' + orderId)).then(res => {
      return parsePartnerDataChangeItemDTO(res);
    });
  }

  private getResourceUrl(path: string): string {
    return this.resourceUrl + path;
  }
}
